import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
} from '@mui/material';

interface DeletePrecedentConfirmationDialogProps {
  open: boolean;
  precedentName: string;
  onClose: () => void;
  onDelete: () => void;
}

const DeletePrecedentConfirmationDialog: React.FC<DeletePrecedentConfirmationDialogProps> = ({
  open,
  precedentName,
  onClose,
  onDelete,
}) => {
  const [confirmName, setConfirmName] = useState('');

  const handleConfirmDelete = () => {
    if (confirmName === precedentName) {
      onDelete();
      onClose();
    } else {
      alert('El nombre ingresado no coincide con el nombre del precedente.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirmar eliminación</DialogTitle>
      <DialogContent>
      <Typography>
  ¿Estás seguro de que deseas eliminar el precedente "
  <Box component="span" fontWeight="bold">{precedentName}</Box>"?  
  Escribe el nombre para confirmar.
</Typography>

        <TextField
          autoFocus
          margin="dense"
          label="Nombre del precedente"
          fullWidth
          variant="outlined"
          value={confirmName}
          onChange={(e) => setConfirmName(e.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={handleConfirmDelete}
          color="error"
          style={{
            textTransform: 'none', // Evita el cambio de texto a mayúsculas
            backgroundColor: '#FF6C84',
            color: 'white',
            flex: 1, // Hace que el botón ocupe todo el espacio disponible
          }}
        >
          Eliminar
        </Button>
        <Button
          onClick={onClose}
          style={{
            textTransform: 'none', // Evita el cambio de texto a mayúsculas
            backgroundColor: '#AAAAAA',
            color: '#ffff',
            flex: 1, // Hace que el botón ocupe todo el espacio disponible
          }}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePrecedentConfirmationDialog;
